module.exports = __webpack_public_path__ + "static/background3-2b6f3edd68888770f915947fe2ad0b5e.jpg";